import { getDownloadCenterFolderPage, getDownloadCenterInitialFolder, } from '../../utils/helpers/downloadCenterHelpers';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeFolder: '', folders: [], folderPages: {}, isDownloading: false,
  paginationHistory: {}, selectedFileNames: {},
};

const getLoadingFolderPage = (currentPage = {}) => ({
  files: currentPage.files || [],
  continuationToken: currentPage.continuationToken || '',
  isLoading: true,
});

const downloadCenterSlice = createSlice({
  name: 'downloadCenter',
  initialState,
  reducers: {
    initialLoad: (state, action) => {
      const data = action.payload;
      const activeFolder = getDownloadCenterInitialFolder(data);

      state.activeFolder = activeFolder;
      state.folders = data?.folders || [];
      state.folderPages = activeFolder
        ? { [activeFolder]: getDownloadCenterFolderPage(data, activeFolder) }
        : {};
    },

    folderSelected: (state, action) => {
      state.activeFolder = action.payload;
      state.selectedFileNames = {};
    },

    folderLoading: (state, action) => {
      const folderName = action.payload;
      state.folderPages[folderName] = getLoadingFolderPage(state.folderPages[folderName]);
    },

    folderPageLoaded: (state, action) => {
      const { data, folderName } = action.payload;

      state.folderPages[folderName] = getDownloadCenterFolderPage(data, folderName);
    },

    nextPage: (state, action) => {
      const { currentPage, folderName } = action.payload;
      const history = state.paginationHistory[folderName] || [];

      state.paginationHistory[folderName] = [
        ...history,
        {
          files: currentPage.files || [],
          continuationToken: currentPage.continuationToken || '',
          isLoading: false,
        },
      ];
      state.selectedFileNames = {};
    },

    previousPageRestored: (state, action) => {
      const folderName = action.payload;
      const history = state.paginationHistory[folderName] || [];
      const previousPage = history[history.length - 1];

      state.folderPages[folderName] = previousPage;
      state.paginationHistory[folderName] = history.slice(0, -1);
      state.selectedFileNames = {};
    },

    fileSelectionToggled: (state, action) => {
      const fileName = action.payload;

      if (state.selectedFileNames[fileName]) {
        delete state.selectedFileNames[fileName];
      } else {
        state.selectedFileNames[fileName] = true;
      }
    },

    downloadStarted: (state) => {
      state.isDownloading = true;
    },

    downloadFinished: (state) => {
      state.isDownloading = false;
    },
  },
});

export const {
  downloadFinished, downloadStarted, fileSelectionToggled, folderLoading, folderPageLoaded,
  folderSelected, initialLoad, nextPage, previousPageRestored,
} = downloadCenterSlice.actions;

export default downloadCenterSlice.reducer;
